import {NgModule} from '@angular/core';
import {PagesSharedModule} from '../../../pages/pages-shared.module';
import {DatabaseLookupInputComponent} from './database-lookup-input.component';

@NgModule({
    imports: [
        PagesSharedModule
    ],
    declarations: [
        DatabaseLookupInputComponent
    ],
    entryComponents: [],
    exports: [
        DatabaseLookupInputComponent
    ]
})
export class DatabaseLookupInputModule {
}
